import { Box, Table, TableBody, TableHead, TableRow } from '@mui/material';
import {
  HeadTableCell,
  RowTableCell,
  CustomButton,
  GeneralTableBox,
  PaginationTable,
  DialogBody,
  SearchBar,
  ActionIconButton,
} from '../../../common/components';

import PostAddIcon from '@mui/icons-material/PostAdd';

import AdditionalDialog from '../dialogs/AdditionalDialog';
import { usePaginatedFilter } from '../../../common/hooks/usePaginatedFilter';
import { formatCurrency } from '../../utils/plansUtils';

const ITEMS_PER_PAGE = 5;

const filterAdditionals = (collection = [], term = '') => {
  if (!term?.trim()) return collection;
  const normalized = term.toLowerCase().trim();
  return collection.filter((additional) =>
    additional.name?.toLowerCase().includes(normalized)
  );
};

const AdditionalsTab = ({
  data,
  selectedItem,
  dialogOpen,
  editMode,
  handleAdd,
  handleEdit,
  handleDelete,
  handleClose,
  handleSave,
}) => {
  const {
    data: paginatedAdditionals,
    page,
    totalPages,
    totalCount,
    rowsPerPage,
    handleSearch,
    handlePageChange,
    handleRowsPerPageChange,
  } = usePaginatedFilter({
    data,
    itemsPerPage: ITEMS_PER_PAGE,
    filterFn: filterAdditionals,
  });

  return (
    <DialogBody sx={{ p: 2, minHeight: '65vh' }}>
      <Box>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
          <CustomButton variant="contained" onClick={handleAdd}>
            <PostAddIcon sx={{ mr: 1 }} />
            Agregar
          </CustomButton>
          <SearchBar onSearch={handleSearch} />
        </Box>

        <GeneralTableBox>
          <Table>
            <TableHead>
              <TableRow>
                <HeadTableCell>Nombre</HeadTableCell>
                <HeadTableCell>Importe ($)</HeadTableCell>
                <HeadTableCell>Se prorratea?</HeadTableCell>
                <HeadTableCell>Es obligatorio?</HeadTableCell>
                <HeadTableCell>Acciones</HeadTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {paginatedAdditionals.map((additional, index) => (
                <TableRow key={additional.id || index}>
                  <RowTableCell>{additional.name}</RowTableCell>
                  <RowTableCell>{formatCurrency(additional.amount)}</RowTableCell>
                  <RowTableCell>{additional.prorate === 1 ? 'Si' : 'No'}</RowTableCell>
                  <RowTableCell>{additional.mandatory === 1 ? 'Si' : 'No'}</RowTableCell>
                  <RowTableCell>
                    <ActionIconButton variant="edit" onClick={() => handleEdit(additional)} />
                    <ActionIconButton
                      variant="delete"
                      onClick={() => handleDelete(additional.uuid)}
                    />
                  </RowTableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>

          {totalCount > rowsPerPage && (
            <PaginationTable
              totalPages={totalPages}
              page={page}
              rowsPerPage={rowsPerPage}
              onPageChange={handlePageChange}
              onRowsPerPageChange={handleRowsPerPageChange}
              totalCount={totalCount}
            />
          )}
        </GeneralTableBox>
      </Box>

      <AdditionalDialog
        open={dialogOpen}
        onClose={handleClose}
        onSave={handleSave}
        selectedItem={selectedItem}
        editMode={editMode}
      />
    </DialogBody>
  );
};

export default AdditionalsTab;
